"use client";

import { c as _c } from "react/compiler-runtime";
import { domMax, LazyMotion, MotionConfig } from "motion/react";
import { AuthProvider } from "@/components/auth/auth-provider";
import { ThemedToaster } from "@/components/shell/themed-toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
export function Providers(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ThemedToaster />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <LazyMotion features={domMax}><MotionConfig reducedMotion="user"><AuthProvider><TooltipProvider>{children}{t1}</TooltipProvider></AuthProvider></MotionConfig></LazyMotion>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}